// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"368":"sese","815":"policelight","816":"Mirror"}[chunkId] + "." + {"368":"67d06c52","815":"16b5d4c2","816":"64f4db80"}[chunkId] + ".css";
};